<template>
  <section>
    <api-info-block title="公共参数" v-model="publicBlockShow">
      <div>
        <div class="param__content">
          <h4 class="api-content__subTitle">公共请求参数</h4>
          <div class="op-tree__content">
            <ul class="list-table__header list-table--reset">
              <li class="td-1">参数</li>
              <li class="td-2">类型（长度）</li>
              <li class="td-3">是否必填</li>
              <!-- <li class="td-4">最大长度</li> -->
              <li class="td-5">描述</li>
              <li class="td-6">示例值</li>
            </ul>
            <Tree
              :data="reqPublicParamData"
              :render="renderContent"
              class="op-tree"
            ></Tree>
          </div>
        </div>
        <div class="param__content" v-show="!callbackStyle">
          <h4 class="api-content__subTitle">公共响应参数</h4>
          <div class="op-tree__content">
            <ul class="list-table__header list-table--reset">
              <li class="td-1">参数</li>
              <li class="td-2">类型（长度）</li>
              <li class="td-3">是否必填</li>
              <!-- <li class="td-4">最大长度</li> -->
              <li class="td-5">描述</li>
              <li class="td-6">示例值</li>
            </ul>
            <Tree
              :data="resPublicParamData"
              :render="renderContent"
              class="op-tree"
            ></Tree>
          </div>
        </div>
      </div>
    </api-info-block>

    <api-info-block title="请求参数">
      <div class="param__content">
        <!-- <Table width="900" :columns="columns1" :data="reqParam"></Table> -->
        <div class="op-tree__content">
          <ul class="list-table__header list-table--reset">
            <li class="td-1">参数</li>
            <li class="td-2">类型（长度）</li>
            <li class="td-3">是否必填</li>
            <!-- <li class="td-4">最大长度</li> -->
            <li class="td-5">描述</li>
            <li class="td-6">示例值</li>
          </ul>
          <Tree
            :data="reqParamData"
            :render="renderContent"
            class="op-tree"
          ></Tree>
        </div>
      </div>
    </api-info-block>

    <api-info-block title="响应参数">
      <div class="param__content">
        <div class="op-tree__content">
          <ul class="list-table__header list-table--reset">
            <li class="td-1">参数</li>
            <li class="td-2">类型（长度）</li>
            <li class="td-3">是否必填</li>
            <!-- <li class="td-4">最大长度</li> -->
            <li class="td-5">描述</li>
            <li class="td-6">示例值</li>
          </ul>
          <Tree
            :data="resParamData"
            :render="renderContent"
            class="op-tree"
          ></Tree>
        </div>
      </div>
    </api-info-block>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import ApiInfoBlock from "./api-info-block.vue";

export default {
  data() {
    this.paramInputMap = {
      1: "是",
      0: "否"
    };

    return {
      publicBlockShow: false // 公共参数的收起和展开
    };
  },

  components: {
    ApiInfoBlock
  },

  props: {
    callbackStyle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      reqPublicParam: "apiDoc/reqPublicParam",
      resPublicParam: "apiDoc/resPublicParam",
      reqParam: "apiDoc/reqParam",
      resParam: "apiDoc/resParam"
    }),

    reqPublicParamData() {
      return this.filter(this.reqPublicParam);
    },
    resPublicParamData() {
      return this.filter(this.resPublicParam);
    },
    reqParamData() {
      return this.filter(this.reqParam);
    },
    resParamData() {
      return this.filter(this.resParam);
    }
  },

  methods: {
    filter(data) {
      let result = [];

      if (data && data.length) {
        result = data.map(item => {
          const {
            paramName,
            paramLength: length,
            paramRemark,
            paramValue,
            paramType,
            paramListtype,
            domainParamList,
            paramInput,
            ...others
          } = item;

          const formartParamType = `${paramType}${
            paramType === "Array" ? "[ ]" : ""
          } ${typeof length === "number" ? "(" + length + ")" : ""}`;

          return {
            expand: false,
            formartParamType,
            children: domainParamList ? this.filter(domainParamList) : [],
            render: this.renderContent,
            paramInputStr: this.paramInputMap[paramInput],
            paramName,
            length,
            paramRemark,
            paramValue
          };
        });
      }

      return result;
    },
    renderContent(h, { root, node, data }) {
      return h(
        "section",
        {
          style: {
            display: "flex",
            justifyContent: "flex-end"
          },
          class: "tr-list__content"
        },
        [
          h(
            "div",
            {
              class: "td-1"
            },
            [h("p", data.paramName)]
          ),
          h(
            "div",
            {
              class: "td-2"
            },
            [h("p", data.formartParamType)]
          ),
          h(
            "div",
            {
              class: "td-3"
            },
            [h("p", data.paramInputStr)]
          ),
          // h(
          //   "div",
          //   {
          //     class: "td-4"
          //   },
          //   [h("p", data.paramLength)]
          // ),
          h(
            "div",
            {
              class: "td-5"
            },
            [h("p", data.paramRemark)]
          ),
          h(
            "div",
            {
              class: "td-6"
            },
            [h("p", data.paramValue)]
          )
        ]
      );
    }
  }
};
</script>

<style lang="less">
.api-info-block {
  .param__content {
    padding: 16px 0px 0px 0px;
  }
  .api-content__subTitle {
    padding: 16px 0;
  }
  .op-tree__content {
    width: 900px;
    margin: 20px 0px;

    ul.list-table--reset {
      li.td-1 {
        padding-left: 30px;
      }

      li {
        padding-left: 4px;
      }
    }

    .list-table__header {
      display: flex;
      justify-content: flex-end;
      background: #f8f8f9;
      line-height: 40px;
      border: 1px solid #e8eaec;
      color: @color-font-primary;
      font-size: 14px;
      font-weight: 500;
    }

    .td-1 {
      width: 100px;
      flex-grow: 1;
      padding-left: 6px;
      flex-shrink: 0;
    }
    .td-2 {
      width: 100px;
      flex-shrink: 0;
    }
    .td-3 {
      width: 70px;
      flex-shrink: 0;
    }
    // .td-4 {
    //   width: 80px;
    //   flex-shrink: 0;
    // }
    .td-5 {
      width: 220px;
      flex-shrink: 0;
      p {
        white-space: pre-line !important;
      }
    }
    .td-6 {
      width: 220px;
      flex-shrink: 0;
      p {
        white-space: pre-line !important;
      }
    }
    .td-1,
    .td-2,
    .td-3,
    .td-4,
    .td-5,
    .td-6 {
      overflow: hidden;
      p {
        display: flex;
        align-items: center;
        word-break: break-all;
        white-space: initial;
        padding: 6px 6px;
        line-height: 20px;
        min-height: 46px;
      }
    }
    .ivu-tree.op-tree {
      border: 1px solid #e8eaec;
      border-top: none;
      border-bottom: none;

      > .ivu-tree-children {
        padding-left: 6px;
      }
      .tr-list__content {
        border-bottom: 1px solid #e8eaec;
        position: relative;
        flex-grow: 1;

        &:first-child {
          border-bottom: 0px;
        }
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          left: -100%;
          bottom: -1px;
          background: #e8eaec;
        }
      }

      .ivu-tree-children {
        > li {
          display: flex;
          flex-wrap: wrap;
          line-height: 48px;
          margin: 0px;

          > ul {
            flex-grow: 1;
            width: auto !important;
          }
        }
        .ivu-tree-arrow {
          display: flex;
          align-items: center;
        }
      }
      .ivu-tree-empty {
        line-height: 48px;
        text-align: center;
        border-bottom: 1px solid #e8eaec;
      }
    }
  }
}

.ivu-tree {
  .ivu-tree-children:not(:last-child) {
    .tr-list__content::before {
      background: #fff !important;
      transform: translateX(5px);
    }
  }

  .ivu-tree-children .ivu-tree-children {
    .td-1 {
      position: relative;

      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        height: calc(50% + 1px);
        width: 6px;
        border-left: 1px solid silver;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        height: 50%;
        width: 6px;
        border-left: 1px solid silver;
      }

      p {
        position: relative;
        text-indent: 4px;

        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 50%;
          height: 2px;
          width: 5px;
          left: 0px;
          border-top: 1px solid silver;
          z-index: 10;
        }
      }
    }
  }

  // .ivu-tree-arrow {
  //   .ivu-icon-ios-arrow-forward::before {
  //     content: "\F330";
  //   }

  //   &.ivu-tree-arrow-open {
  //     .ivu-icon-ios-arrow-forward::before {
  //       content: "\F379";
  //     }
  //   }
  // }
}
</style>
